import styled, {createGlobalStyle} from 'styled-components';
import {dFlexColumn, dFlexStart, dInlineFlex, alignCenter, justifyCenter} from '../../../../../globalVariables/GlobalFlex';
import {mobileMedia} from '../../../../../globalVariables/GlobalVariables';
import zIndex from '../../../../../globalVariables/zIndex';

export const HelperTooltipZIndexFix = createGlobalStyle`
    #helper-tooltip {
        z-index: ${zIndex.upperModal};
    }
`;

export const summaryField = styled.div`
    ${dFlexColumn};
    gap: var(--space-sm);
    width: 100%;
`;

export const summaryHeader = styled.div`
    ${dFlexStart};
    gap: var(--space-sm);
    width: 100%;
`;

export const summaryLabel = styled.span`
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-body);
    line-height: var(--line-height-body);
    color: var(--TA-color-text-default);
`;

export const summaryIcon = styled.span`
    ${dInlineFlex}
    ${alignCenter}
    ${justifyCenter}
    width: var(--space-xl);
    height: var(--space-xl);
    color: var(--TA-color-text-default);
`;

export const editorWrap = styled.div`
    width: 100%;
    .quill {
        background: var(--TA-color-bg-surface-default);
    }
`;

export const fieldsTwoCols = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--space-lg) var(--space-xl);
    width: 100%;

    ${mobileMedia} {
        grid-template-columns: 1fr;
    }
`;

export const casualPriceWrap = styled.div`
    position: relative;
    width: 100%;
`;

export const casualPriceToggle = styled.div`
    position: absolute;
    inset-inline-end: 0;
    top: 3px;
    z-index: ${zIndex.baseRaised};
`;

export const fieldsThreeCols = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: var(--space-lg) var(--space-xl);
    width: 100%;

    ${mobileMedia} {
        grid-template-columns: 1fr;
    }
`;
